<template>
	<div>
		<footer class="py-4 mt-4">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<div class="row">
							<div class="col-12 col-md-4  mb-5">
								<img src="@/assets/logo-dark.png" alt="" class="logo" />
								<div class="mt-4">
									<div>099 277 669 - 096 247 661</div>
									<!-- <div>Dirección 1234, Montevideo</div> -->
									<div>info@surcampers.uy</div>
								</div>
							</div>
							<div class="col-12 col-md-4  mb-5 mt-4">
								<h4 class="footer-title"></h4>
								<router-link tag="a" :to="`/`"> Inicio </router-link><br />
								<router-link tag="a" :to="`/campers`"> Campers </router-link><br />
								<router-link tag="a" :to="`/productos`"> Accesorios </router-link><br />
								<router-link tag="a" :to="`/quienes-somos`"> Quienes somos </router-link><br />
								<router-link tag="a" :to="`/preguntas-frecuentes`"> Preguntas frecuentes </router-link><br />
								<router-link tag="a" :to="`/politica-privacidad`"> Política de privacidad</router-link><br />
								<router-link tag="a" :to="`/contacto`">
									Contacto
								</router-link>
							</div>
							<div class="col-12 col-md-4 mt-4 mb-5 text-md-right">
								<div>
									<h4 class="footer-title">
										Nuestras redes
									</h4>
									<div class="redes">
										<a href="https://www.facebook.com/surcampersuruguay/" target="_blank" class="red" :style="`background-image:url(${require('@/assets/img/icon-facebook.png')})`"></a>
										<a href="https://www.instagram.com/surcampersuruguay" target="_blank" class="red" :style="`background-image:url(${require('@/assets/img/icon-instagram.png')})`"></a>
									</div>
								</div>
								<div class="mt-4">
									<h4 class="footer-title">
										Metodos de pago
									</h4>
									<div class="payment-methods">
										<div class="payment" :style="`background-image:url(${require('@/assets/img/icon-payment-visa.png')})`"></div>
										<div class="payment" :style="`background-image:url(${require('@/assets/img/icon-payment-master.png')})`"></div>
										<div class="payment" :style="`background-image:url(${require('@/assets/img/icon-payment-oca.png')})`"></div>
										<div class="payment" :style="`background-image:url(${require('@/assets/img/icon-payment-abitab.png')})`"></div>
										<div class="payment" :style="`background-image:url(${require('@/assets/img/icon-payment-redpagos.png')})`"></div>
										<div class="payment" :style="`background-image:url(${require('@/assets/img/icon-payment-brou.png')})`"></div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- <div class="col-12 col-md-6 col-lg-4 order-md-2 order-lg-3 mb-5 mt-2 text-right">
						<img
							src="https://maps.googleapis.com/maps/api/staticmap?center=-34.8980529,-56.1827367&zoom=13&size=300x220&maptype=roadmap&markers=color:blue%7C-34.8980529,-56.1827367&key=AIzaSyCj3tM4TV-9pxXhbTpvEd0v2K1bFCZOjz0"
							alt=""
							class="img-fluid"
						/>
					</div> -->
				</div>
			</div>
			<div class="container-fluid credits text-center p-3">
				<small>Sur Campers Copyright &copy; {{ year }} </small>
			</div>
		</footer>
	</div>
</template>

<script>
export default {
	name: 'Footer',

	data() {
		return {
			year: new Date().getFullYear(),
		}
	},
}
</script>

<style scoped>
footer {
	border-top: solid rgb(230, 230, 230) 1px;
	margin-top: 32px;
	width: 100%;
	color: rgb(8, 8, 8);
	background-color: #fff;
}
.logo {
	max-height: 72px;
}
h5 {
	font-size: 15px;
}
.footer-title {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 6px;
}
a {
	color: rgb(8, 8, 8);
}
.fa {
	color: #cfcfcf;
}
.logo {
	max-width: 152px;
}
.credits {
}

.redes {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 12px;
	flex-wrap: wrap;
}
.red {
	width: 38px;
	height: 38px;
	background-size: contain;
	background-repeat: no-repeat;
}
.payment-methods {
	display: flex;
	align-items: center;
	justify-content: flex-end;

	gap: 3px;
	flex-wrap: wrap;
}

.payment {
	width: 74px;
	height: 40px;
	background-size: contain;
	background-repeat: no-repeat;
}

@media (max-width: 768px) {
	footer {
		text-align: center;
	}

	.redes,
	.payment-methods {
		justify-content: center;
	}
}
</style>
